import { connect } from 'react-redux';
import CalendarRefresh from 'components/CalendarRefresh/CalendarRefresh';
import { refreshCalendars } from 'actions/Calendar';
import { isRefreshingCalendars } from 'selectors/calendar';
import _get from 'lodash/get';

const mapStateToProps = (state) => {
  return {
    updateTime: _get(state, 'app.calendar.updatedTime'),
    isRefreshing: isRefreshingCalendars(state)
  };
};

const mapDispatchToProps = (dispatch) => ({
  refresh: () => dispatch(refreshCalendars())
});

export default connect(mapStateToProps, mapDispatchToProps)(CalendarRefresh);
